import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SendPhoneNumber from '../SendPhoneNumber';
import { getApplicationDraft, buildConsentRouteState, buildConfirmRouteState } from '../../../utils/applicationDraft';
import { clearQuickCashPendingAttribution, getQuickCashDraft } from '../storage';
import { QUICK_CASH_ROUTES } from '../routes';

const buildMergedConfirmState = (draft) => draft?.form1 ? {
  status: true,
  form1: draft.form1,
  source: 'applicationForm1Merge',
} : null;

const getRegisterResumeRoute = (draft) => {
  // 기존 register draft의 마지막 단계에 맞춰 사용자가 작성 중이던 화면으로 복귀시킨다.
  const consentState = buildConsentRouteState(draft?.meta);
  if (!consentState) return null;

  if (draft.currentStep === 'confirm') {
    const confirmState = draft?.form1?.application_form1_merged
      ? buildMergedConfirmState(draft)
      : buildConfirmRouteState(draft);
    if (confirmState) return { pathname: '/application-confirm-data', state: confirmState };
  }
  if (draft.currentStep === 'form1' || draft.currentStep === 'form') {
    return { pathname: '/application-form-1', state: consentState };
  }
  return { pathname: '/application-consent', state: consentState };
};

const getQuickCashResumeRoute = (draft) => {
  // 새로고침이나 재진입 시 Quick Cash 전용 draft만 사용해 현재 단계를 복원한다.
  const consentState = buildConsentRouteState(draft?.meta);
  if (!consentState) return null;

  if (draft.currentStep === 'confirm' && draft.form1) {
    return { pathname: QUICK_CASH_ROUTES.confirm, state: buildMergedConfirmState(draft) };
  }
  if (draft.currentStep === 'form1' || draft.currentStep === 'form') {
    return { pathname: QUICK_CASH_ROUTES.form, state: consentState };
  }
  return { pathname: QUICK_CASH_ROUTES.consent, state: consentState };
};

function Entry() {
  const navigate = useNavigate();
  const [showSwitchNotice, setShowSwitchNotice] = useState(false);
  const [showPhoneInput, setShowPhoneInput] = useState(false);

  useEffect(() => {
    const quickCashDraft = getQuickCashDraft();

    if (quickCashDraft) {
      const resumeRoute = getQuickCashResumeRoute(quickCashDraft);
      if (resumeRoute) {
        navigate(resumeRoute.pathname, { replace: true, state: resumeRoute.state });
        return;
      }
    }

    const registerDraft = getApplicationDraft();
    if (registerDraft?.meta?.phone) {
      // URL 진입만으로 기존 신청을 삭제하지 않고 사용자가 전환 여부를 선택하게 한다.
      setShowSwitchNotice(true);
      return;
    }
    setShowPhoneInput(true);
  }, [navigate]);

  const resumeRegister = () => {
    clearQuickCashPendingAttribution();
    const resumeRoute = getRegisterResumeRoute(getApplicationDraft());
    if (resumeRoute) {
      navigate(resumeRoute.pathname, { state: resumeRoute.state });
      return;
    }
    navigate('/?open=register');
  };

  if (showSwitchNotice) {
    return (
      <div className="p-6 pt-32 fixed w-full z-20 top-0 left-0 flex items-start justify-center h-full" style={{ backgroundColor: '#0000004d' }}>
        <div className="rounded-md w-full border-primary py-7 px-7 bg-white" style={{ maxWidth: 414 }}>
          <p className="text-2xl text-primary2 text-center font-semibold">正在申請其他貸款產品</p>
          <p className="text-gray text-center mt-5">閣下尚有未完成之貸款申請，當完成「急借2萬定額貸款」一次性手機驗證後，原有未遞交之申請資料將會被移除。</p>
          <div className="flex flex-col items-center gap-4 mt-7">
            <button type="button" onClick={resumeRegister} className="rounded-full text-white text-base px-10 py-3 bg-primary2 w-full">
              繼續原有申請
            </button>
            <button type="button" onClick={() => { setShowSwitchNotice(false); setShowPhoneInput(true); }} className="rounded-full text-white text-base px-10 py-3 bg-primary w-full">
              申請急借2萬定額貸款
            </button>
          </div>
        </div>
      </div>
    );
  }

  return showPhoneInput ? <SendPhoneNumber /> : null;
}

export default Entry;
